<template>
  <div
    class="text-regal-gray bg-main__transition "
    :class="{ 'bg-regal-gray': backgroundGray }"
  >
    <x-header @showStartScreen="showStartScreen" :changeColour="backgroundGray"/>
    <transition name="slide-fade" appear mode="out-in">
      <order-naan-component
        :key="currentIndex"
        v-if="currentIndex === 1"
        @naanAmountToOrder="setNaanAmountToOrder"
      />
      <amount-confirmation-component
        :key="currentIndex"
        v-if="currentIndex === 2"
        :naan-amount="naanQuantity"
        :changeFooterColor="backgroundGray"
        @confirmNaanAmount="confirmNaanAmount"
      />
      <person-amount-component
        :key="currentIndex"
        v-if="currentIndex === 3"
        @personsAmount="setPersonsAmount"
      />
      <rice-amount-component
        :key="currentIndex"
        v-if="currentIndex === 4"
        @riceAmount="setRiceAmount"
      />
      <hours-amount-component
        :key="currentIndex"
        v-if="currentIndex === 5"
        @hoursAmount="setHoursAmount"
      />
      <result-component
        :key="currentIndex"
        :naan-amount="naanResult"
        :persons-amount="personQuantity"
        v-if="currentIndex === 6"
        :changeFooterColor="backgroundGray"
      />
    </transition>
  </div>
</template>

<script>
import XHeader from "@/components/Header/XHeader";
import OrderNaanComponent from "@/components/ScreenComponents/OrderNaanComponent";
import AmountConfirmationComponent from "@/components/ScreenComponents/AmountConfirmationComponent";
import PersonAmountComponent from "@/components/ScreenComponents/PersonAmountComponent";
import RiceAmountComponent from "@/components/ScreenComponents/RiceAmountComponent";
import HoursAmountComponent from "@/components/ScreenComponents/HoursAmountComponent";
import ResultComponent from "@/components/ScreenComponents/ResultComponent";

export default {
  name: "MainPage",
  components: {
    ResultComponent,
    HoursAmountComponent,
    RiceAmountComponent,
    PersonAmountComponent,
    AmountConfirmationComponent,
    OrderNaanComponent,
    XHeader
  },
  data() {
    return {
      currentIndex: 1,
      naanQuantity: null,
      personQuantity: null,
      riceQuantity: null,
      hoursQuantity: null,
      resultQuantity: null
    };
  },
  computed: {
    backgroundGray() {
      return (this.naanQuantity === 4 && this.currentIndex === 2) || (this.naanResult === 4 && this.currentIndex === 6);
    },
    naanResult(){
      if(Math.round(this.resultQuantity) <= 1){
        return 1
      }else{
        return Math.round(this.resultQuantity)
      }
    }
  },
  methods: {
    incrementCurrentIndex(){
      this.currentIndex++
    },
    showStartScreen() {
      this.currentIndex = 1
    },
    setNaanAmountToOrder(amount) {
      this.incrementCurrentIndex()
      this.naanQuantity  = amount;
    },
    confirmNaanAmount() {
      this.incrementCurrentIndex()
    },
    setPersonsAmount(personQuantity) {
      this.incrementCurrentIndex()
      this.personQuantity = this.resultQuantity = personQuantity;
    },
    setRiceAmount(riceQuantity) {
      this.incrementCurrentIndex()
      this.riceQuantity = riceQuantity;
      if(this.riceQuantity >= this.personQuantity){
        this.resultQuantity *= 0.5
      }
    },
    setHoursAmount(hoursQuantity) {
      this.incrementCurrentIndex()
      this.hoursQuantity = hoursQuantity;
      if(this.hoursQuantity >= 5 ){
        this.resultQuantity *= 1.5;
      } else if (this.hoursQuantity <= 2 ){
      this.resultQuantity *= 0.5
      }
    }
  }
};
</script>
<style scoped>
  .bg-main__transition {
    transition: background-color 1s ease;
    min-height: 100vh;
  }
</style>
